import { RootState } from "@/vuex/types";
import { Module } from "vuex";
import { actions } from "./locations.actions";
import { getters } from "./locations.getters";
import { mutations } from "./locations.mutations";
import { state } from "./locations.state";
import { LocationState } from "./locations.types";

const namespaced: boolean = true;

export const LocationModule: Module<LocationState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
